import { addDays, format, formatDistanceToNow, getTime, isValid } from 'date-fns';

// yyyy-mm-dd and yyyy-m-d (Iso date WITHOUT time string)
const isShorthandIso = (date: Date | string | number | undefined) => {
  if (!date) return false;
  return new RegExp(/^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/).test(date.toString());
};

// Appends "T00:00:00.000" to shorthand iso date. Without time string, yyyy-mm-dd to Date conversions can cause the result to be a day behind.
export function fIsoDateToIsoDateTime(date: string) {
  if (!date || !isShorthandIso(date)) {
    return '';
  }
  return new Date(`${date}T00:00:00.000`);
}

export function fDate(date: Date | string | number) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateStandardString(date: Date | string | undefined) {
  if (!date) {
    return '';
  }

  const isString = typeof date === 'string';

  let parsedDate;
  switch (true) {
    case isShorthandIso(date) && isString: {
      parsedDate = fIsoDateToIsoDateTime(date);
      break;
    }
    default:
      parsedDate = new Date(date);
      break;
  }

  if (!isValid(parsedDate)) {
    return '';
  }

  const isUTC = isString && date.endsWith('Z');
  if (isUTC) {
    // Add a day if the date is in UTC format
    return format(addDays(parsedDate, 1), 'MM/dd/yyyy');
  }

  return format(parsedDate, 'MM/dd/yyyy');
}

export function fDateToIsoString(date: Date | string) {
  const dateFormat = 'yyyy-MM-dd';
  if (!date) {
    return '';
  }
  return format(new Date(date), dateFormat);
}

export function fDateToLocalString(date: Date | string | number) {
  return new Date(date).toLocaleDateString();
}

export function fDateTime(date: Date | string | number) {
  return format(new Date(date), 'dd MMM yyyy p');
}

export function fTimestamp(date: Date | string | number) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date: Date | string | number) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date: Date | string | number) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}

export function getMonthDifference(startDate: Date, endDate: Date): number {
  return (endDate.getFullYear() - startDate.getFullYear()) * 12 + endDate.getMonth() - startDate.getMonth();
}
